import { Box, Button, Typography } from '@mui/material'
import EmptyTestsIcon from '../../../../assets/iconComponents/EmptyTestsIcon'
import GeneratingTestsIcon from '../../../../assets/iconComponents/GeneratingTestsIcon'

const TestCasesEmpty = ({
  isGenerateLoading,
  handleGenerateTestCases,
  noticeText, // optional inline notice,
  isScanLoading,
}) => {
  return (
    <Box className="testCasesTabEmptyContent">
      { isGenerateLoading
        ? <Box className='testsEmpty'>
          <Box className='testsGeneratingIconContainer'>
            <GeneratingTestsIcon />
          </Box>
          <Typography className='testsEmptyLabel'>
            Generating...
          </Typography>
          <Typography className='testsEmptyText'>
            Generating Test Cases is nearly ready
          </Typography>
        </Box>
        : <Box className='testsEmpty'>
          <Box className='testsEmptyIconContainer'>
            <EmptyTestsIcon />
          </Box>
          <Typography className='testsEmptyLabel'>
           {noticeText ? noticeText : 'No Test Cases Yet'}
          </Typography>
          <Typography className='testsEmptyText' align="center">
            Create E2E tests for simple, page-based features.
          </Typography>
          <Button
            className="testsEmptyActionButton"
            variant="contained"
            color="secondary"
            onClick={handleGenerateTestCases}
            disabled={isScanLoading}
          >
            GENERATE TEST CASES
          </Button>
        </Box>
      }
    </Box>
  )
}

export default TestCasesEmpty
